import { styled } from "@mui/material/styles";
import { HubCardStack } from "../../components";
import { Typography } from "@mui/material";
import { proseSx } from "../HubEditor/styles";

export const StyledCardStack = styled(HubCardStack)(({ theme }) => ({
  gap: "10px",
  padding: "10px",
  backgroundColor: theme.palette.hubColors.greyLightest,
  borderRadius: "5px",
  transition: "all 0.1s ease-in-out",
  border: "none",
  width: "100%",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  ...proseSx(theme)["& .tiptap"],
  "& .entity-link": {
    display: "inline-flex",
    alignItems: "center",
    gap: 3,
    padding: "1px 6px",
    borderRadius: 4,
    fontSize: 12,
    fontWeight: 500,
    cursor: "pointer",
    userSelect: "none",
  },
  "& .entity-work_order": { background: "#eef2ff", color: "#6366f1" },
  "& .entity-part": { background: "#ecfeff", color: "#0891b2" },
  "& .entity-quote": { background: "#fffbeb", color: "#d97706" },
  "& .entity-order": { background: "#f0fdf4", color: "#16a34a" },
  "& .entity-customer": { background: "#f5f3ff", color: "#7c3aed" },
  "& .entity-default": { background: "#f3f4f6", color: "#6b7280" },
}));
